<template>
	<el-dialog :visible.sync="visible" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" width="550px">
		<span slot="title" class="dialog-title">
			<span>{{ showTitle }}</span>
			<img src="@/assets/images/close.png" alt="" @click="visible = false" />
		</span>
		<el-form ref="form" :model="form" :rules="rules">
			<el-row :gutter="20">
				<el-col :span="12">
					<el-form-item label="开始日期" prop="startDate">
						<el-date-picker v-model="form.startDate" type="date" value-format="yyyy-MM-dd" placeholder="请选择" class="full-width"></el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="结束日期" prop="endDate">
						<el-date-picker v-model="form.endDate" type="date" value-format="yyyy-MM-dd" placeholder="请选择" class="full-width"></el-date-picker>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>

		<div class="content">
			<el-row :gutter="24">
				<el-button :loading="loading" class="submit-btn mr20" @click="handleExport">直接导出</el-button>
				<el-button :loading="asyncLoading" class="submit-btn" @click="handleAsyncExport">后台导出</el-button>
			</el-row>
		</div>
		<div class="tip">
			<span class="red-asterisk">*</span>
			后台导出是通过邮件的方式下载。
		</div>
	</el-dialog>
</template>

<script>
import { debounce } from "@/utils/debounce";

export default {
	name: "exportFileter",
	props: {},
	data() {
		return {
			visible: false,
			loading: false,
			asyncLoading: false,
			apiUrl: "",
			showTitle: "用户积分导出",
			type: String, //类型
			form: {
				startDate: "",
				endDate: "",
				searchKey: "",
				roleName: "",
				active: "",
				area: "",
			},
			rules: {
				startDate: [{ required: true, message: "请选择开始日期", trigger: "change" }],
				endDate: [{ required: true, message: "请选择结束日期", trigger: "change" }],
			},
		};
	},
	methods: {
		show(type, data) {
			this.loading = false;
			this.$refs.form && this.$refs.form.resetFields();
			this.type = type;
			if (type === "bbs") {
				this.showTitle = "用户BBS参与情况导出";
			} else {
				this.showTitle = "用户积分导出";
			}
			this.form = data;
			this.$nextTick(() => {
				this.visible = true;
			});
		},
		// 直接导出
		handleExport: debounce(function () {
			if (this.visible === false) {
				return;
			}
			// 检查 结束日期是否大于开始日期
			if (this.form.startDate && this.form.endDate) {
				if (this.form.startDate > this.form.endDate) {
					this.$message.error("结束日期不能小于开始日期");
					return;
				}
			}
			if (this.type === "bbs") {
				this.apiUrl = "sysUserExportBbsData";
			} else {
				this.apiUrl = "sysUserExportPoints";
			}

			this.loading = true;
			this.$refs["form"].validate((valid) => {
				if (valid) {
					let that = this;
					that.$request.post(that.apiUrl, false, that.form, function (res) {
						that.loading = false;
						if (res.code == "0") {
							const linkNode = document.createElement("a");
							linkNode.style.display = "none";
							linkNode.href = res.data;
							document.body.appendChild(linkNode);
							linkNode.click(); //模拟在按钮上的一次鼠标单击
							URL.revokeObjectURL(linkNode.href); // 释放URL 对象
							document.body.removeChild(linkNode);
						} else {
							that.$message.error(res.msg);
						}
					});
				} else {
					this.loading = false;
					return false;
				}
			});
		}, 1000),
		// 后台导出
		handleAsyncExport: debounce(function () {
			if (this.visible === false) {
				return;
			}

			if (this.type === "bbs") {
				this.apiUrl = "sysUserAsyncExportBbsData";
			} else {
				this.apiUrl = "sysUserAsyncExportPoints";
			}
			this.visible = false;
			this.$message.success("导出完成，稍等请检查您的邮件。");
			// this.asyncLoading = true;
			this.$refs["form"].validate((valid) => {
				if (valid) {
					let that = this;
					that.$request.post(
						that.apiUrl,
						false,
						that.form,
						function (res) {
							// that.asyncLoading = false;
							// that.$message.success("导出完成，稍等请检查您的邮件。");
							// that.visible = false;
						},
						function () {
							// that.asyncLoading = false;
							// that.$message.error("导出失败！");
						},
					);
				} else {
					// this.asyncLoading = false;
					return false;
				}
			});
		}, 1000),
	},
};
</script>

<style scoped lang="scss">
.dialog-title {
	display: block;
	text-align: center;

	span {
		color: #222;
		font-weight: 600;
		font-size: 20px;
	}

	img {
		width: 28px;
		float: right;
		cursor: pointer;
	}
}

.el-form-item {
	margin-bottom: 18px;

	.el-select {
		width: 100%;
	}
}

.submit-btn {
	background-color: #117ffc;
	color: #fff;
	border-color: #117ffc;
	width: 150px;
	height: 40px;
	line-height: 13px;
	border-radius: 4px;
	font-size: 15px;
}

.content {
	text-align: center;
	margin-top: 15px;
	margin-bottom: 15px;
}

.tip {
	text-align: center;
	padding-top: 10px;
}

.red-asterisk {
	color: red;
}
</style>
